function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" {...props}><title>icon-play</title><path d="M10.579 24.795V7.203L26.83 16zm.625-16.544v15.498L25.525 16z" /><path d="M16 32h-.001c-8.837 0-16-7.164-16-16s7.164-16 16-16c8.837 0 16 7.164 16 16v.001c-.011 8.832-7.168 15.989-15.999 16zM16 .805h-.001C7.607.805.803 7.608.803 16.001s6.803 15.196 15.196 15.196c8.392 0 15.196-6.803 15.196-15.196C31.185 7.613 24.388.816 16.001.805z" /></svg>;
});